import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import MapContext from './MapContext';

export default class MapControl extends React.Component {
  constructor(props) {
    super(props);

    this.container = document.createElement('div');
    this.container.className = ['maplibregl-ctrl', props.className].filter(Boolean).join(' ');
    this.control = {
      onAdd: () => this.container,
      onRemove: () => this.container.remove()
    };
  }

  componentDidMount() {
    this.context.map.addControl(this.control, this.props.position);
  }

  componentWillUnmount() {
    if (this.context.isRemoved()) return;

    this.context.map.removeControl(this.control);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.container);
  }
}

MapControl.contextType = MapContext;

MapControl.defaultProps = {
  position: 'top-right'
};

MapControl.propTypes = {
  position: PropTypes.oneOf(['top-left', 'top-right', 'bottom-left', 'bottom-right']),
  className: PropTypes.string,
  children: PropTypes.node
};
